import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _6f6c9392 = () => interopDefault(import('../pages/about.vue' /* webpackChunkName: "pages/about" */))
const _0620d853 = () => interopDefault(import('../pages/account-removal-request.vue' /* webpackChunkName: "pages/account-removal-request" */))
const _550bc9ec = () => interopDefault(import('../pages/certificates/index.vue' /* webpackChunkName: "pages/certificates/index" */))
const _6b54c4b6 = () => interopDefault(import('../pages/contact-us.vue' /* webpackChunkName: "pages/contact-us" */))
const _412b5a3d = () => interopDefault(import('../pages/drivers-and-manuals/index.vue' /* webpackChunkName: "pages/drivers-and-manuals/index" */))
const _12056546 = () => interopDefault(import('../pages/e-catalogue.vue' /* webpackChunkName: "pages/e-catalogue" */))
const _15836661 = () => interopDefault(import('../pages/news/index.vue' /* webpackChunkName: "pages/news/index" */))
const _458060d2 = () => interopDefault(import('../pages/promo/index.vue' /* webpackChunkName: "pages/promo/index" */))
const _012835f3 = () => interopDefault(import('../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _77c33a36 = () => interopDefault(import('../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _630251a2 = () => interopDefault(import('../pages/search/drivers.vue' /* webpackChunkName: "pages/search/drivers" */))
const _d3161a2e = () => interopDefault(import('../pages/search/faqs.vue' /* webpackChunkName: "pages/search/faqs" */))
const _99574ac2 = () => interopDefault(import('../pages/search/news.vue' /* webpackChunkName: "pages/search/news" */))
const _148e76b0 = () => interopDefault(import('../pages/search/products.vue' /* webpackChunkName: "pages/search/products" */))
const _ea0fdc1e = () => interopDefault(import('../pages/user-help-desk/index.vue' /* webpackChunkName: "pages/user-help-desk/index" */))
const _50d193a8 = () => interopDefault(import('../pages/where-to-buy/index.vue' /* webpackChunkName: "pages/where-to-buy/index" */))
const _cb6c3a90 = () => interopDefault(import('../pages/user-help-desk/faq/index.vue' /* webpackChunkName: "pages/user-help-desk/faq/index" */))
const _e1b72352 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _ced97d20 = () => interopDefault(import('../pages/user-help-desk/faq/_slug.vue' /* webpackChunkName: "pages/user-help-desk/faq/_slug" */))
const _58790c7c = () => interopDefault(import('../pages/certificates/_slug.vue' /* webpackChunkName: "pages/certificates/_slug" */))
const _13ccc519 = () => interopDefault(import('../pages/news/_slug.vue' /* webpackChunkName: "pages/news/_slug" */))
const _3af49a90 = () => interopDefault(import('../pages/product-category/_category/index.vue' /* webpackChunkName: "pages/product-category/_category/index" */))
const _5de9fa22 = () => interopDefault(import('../pages/product/_slug.vue' /* webpackChunkName: "pages/product/_slug" */))
const _48eda362 = () => interopDefault(import('../pages/promo/_slug.vue' /* webpackChunkName: "pages/promo/_slug" */))
const _50746768 = () => interopDefault(import('../pages/product-category/_category/_subcategory/index.vue' /* webpackChunkName: "pages/product-category/_category/_subcategory/index" */))
const _5cd98fda = () => interopDefault(import('../pages/product-category/_category/_subcategory/_subsubcategory/index.vue' /* webpackChunkName: "pages/product-category/_category/_subcategory/_subsubcategory/index" */))
const _0bc54daa = () => interopDefault(import('../pages/product-category/_category/_subcategory/_subsubcategory/_subsubsubcategory/index.vue' /* webpackChunkName: "pages/product-category/_category/_subcategory/_subsubcategory/_subsubsubcategory/index" */))
const _e52465e2 = () => interopDefault(import('../pages/_slug.vue' /* webpackChunkName: "pages/_slug" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _6f6c9392,
    name: "about___en"
  }, {
    path: "/about",
    component: _6f6c9392,
    name: "about___uk"
  }, {
    path: "/about",
    component: _6f6c9392,
    name: "about___bg"
  }, {
    path: "/about",
    component: _6f6c9392,
    name: "about___cs"
  }, {
    path: "/about",
    component: _6f6c9392,
    name: "about___ro"
  }, {
    path: "/about",
    component: _6f6c9392,
    name: "about___sk"
  }, {
    path: "/about",
    component: _6f6c9392,
    name: "about___ru"
  }, {
    path: "/about",
    component: _6f6c9392,
    name: "about___en"
  }, {
    path: "/about",
    component: _6f6c9392,
    name: "about___en"
  }, {
    path: "/about",
    component: _6f6c9392,
    name: "about___en"
  }, {
    path: "/account-removal-request",
    component: _0620d853,
    name: "account-removal-request___en"
  }, {
    path: "/account-removal-request",
    component: _0620d853,
    name: "account-removal-request___uk"
  }, {
    path: "/account-removal-request",
    component: _0620d853,
    name: "account-removal-request___bg"
  }, {
    path: "/account-removal-request",
    component: _0620d853,
    name: "account-removal-request___cs"
  }, {
    path: "/account-removal-request",
    component: _0620d853,
    name: "account-removal-request___ro"
  }, {
    path: "/account-removal-request",
    component: _0620d853,
    name: "account-removal-request___sk"
  }, {
    path: "/account-removal-request",
    component: _0620d853,
    name: "account-removal-request___ru"
  }, {
    path: "/account-removal-request",
    component: _0620d853,
    name: "account-removal-request___en"
  }, {
    path: "/account-removal-request",
    component: _0620d853,
    name: "account-removal-request___en"
  }, {
    path: "/account-removal-request",
    component: _0620d853,
    name: "account-removal-request___en"
  }, {
    path: "/certificates",
    component: _550bc9ec,
    name: "certificates___en"
  }, {
    path: "/certificates",
    component: _550bc9ec,
    name: "certificates___uk"
  }, {
    path: "/certificates",
    component: _550bc9ec,
    name: "certificates___bg"
  }, {
    path: "/certificates",
    component: _550bc9ec,
    name: "certificates___cs"
  }, {
    path: "/certificates",
    component: _550bc9ec,
    name: "certificates___ro"
  }, {
    path: "/certificates",
    component: _550bc9ec,
    name: "certificates___sk"
  }, {
    path: "/certificates",
    component: _550bc9ec,
    name: "certificates___ru"
  }, {
    path: "/certificates",
    component: _550bc9ec,
    name: "certificates___en"
  }, {
    path: "/certificates",
    component: _550bc9ec,
    name: "certificates___en"
  }, {
    path: "/certificates",
    component: _550bc9ec,
    name: "certificates___en"
  }, {
    path: "/contact-us",
    component: _6b54c4b6,
    name: "contact-us___en"
  }, {
    path: "/contact-us",
    component: _6b54c4b6,
    name: "contact-us___uk"
  }, {
    path: "/contact-us",
    component: _6b54c4b6,
    name: "contact-us___bg"
  }, {
    path: "/contact-us",
    component: _6b54c4b6,
    name: "contact-us___cs"
  }, {
    path: "/contact-us",
    component: _6b54c4b6,
    name: "contact-us___ro"
  }, {
    path: "/contact-us",
    component: _6b54c4b6,
    name: "contact-us___sk"
  }, {
    path: "/contact-us",
    component: _6b54c4b6,
    name: "contact-us___ru"
  }, {
    path: "/contact-us",
    component: _6b54c4b6,
    name: "contact-us___en"
  }, {
    path: "/contact-us",
    component: _6b54c4b6,
    name: "contact-us___en"
  }, {
    path: "/contact-us",
    component: _6b54c4b6,
    name: "contact-us___en"
  }, {
    path: "/drivers-and-manuals",
    component: _412b5a3d,
    name: "drivers-and-manuals___en"
  }, {
    path: "/drivers-and-manuals",
    component: _412b5a3d,
    name: "drivers-and-manuals___uk"
  }, {
    path: "/drivers-and-manuals",
    component: _412b5a3d,
    name: "drivers-and-manuals___bg"
  }, {
    path: "/drivers-and-manuals",
    component: _412b5a3d,
    name: "drivers-and-manuals___cs"
  }, {
    path: "/drivers-and-manuals",
    component: _412b5a3d,
    name: "drivers-and-manuals___ro"
  }, {
    path: "/drivers-and-manuals",
    component: _412b5a3d,
    name: "drivers-and-manuals___sk"
  }, {
    path: "/drivers-and-manuals",
    component: _412b5a3d,
    name: "drivers-and-manuals___ru"
  }, {
    path: "/drivers-and-manuals",
    component: _412b5a3d,
    name: "drivers-and-manuals___en"
  }, {
    path: "/drivers-and-manuals",
    component: _412b5a3d,
    name: "drivers-and-manuals___en"
  }, {
    path: "/drivers-and-manuals",
    component: _412b5a3d,
    name: "drivers-and-manuals___en"
  }, {
    path: "/e-catalogue",
    component: _12056546,
    name: "e-catalogue___en"
  }, {
    path: "/e-catalogue",
    component: _12056546,
    name: "e-catalogue___uk"
  }, {
    path: "/e-catalogue",
    component: _12056546,
    name: "e-catalogue___bg"
  }, {
    path: "/e-catalogue",
    component: _12056546,
    name: "e-catalogue___cs"
  }, {
    path: "/e-catalogue",
    component: _12056546,
    name: "e-catalogue___ro"
  }, {
    path: "/e-catalogue",
    component: _12056546,
    name: "e-catalogue___sk"
  }, {
    path: "/e-catalogue",
    component: _12056546,
    name: "e-catalogue___ru"
  }, {
    path: "/e-catalogue",
    component: _12056546,
    name: "e-catalogue___en"
  }, {
    path: "/e-catalogue",
    component: _12056546,
    name: "e-catalogue___en"
  }, {
    path: "/e-catalogue",
    component: _12056546,
    name: "e-catalogue___en"
  }, {
    path: "/news",
    component: _15836661,
    name: "news___en"
  }, {
    path: "/news",
    component: _15836661,
    name: "news___uk"
  }, {
    path: "/news",
    component: _15836661,
    name: "news___bg"
  }, {
    path: "/news",
    component: _15836661,
    name: "news___cs"
  }, {
    path: "/news",
    component: _15836661,
    name: "news___ro"
  }, {
    path: "/news",
    component: _15836661,
    name: "news___sk"
  }, {
    path: "/news",
    component: _15836661,
    name: "news___ru"
  }, {
    path: "/news",
    component: _15836661,
    name: "news___en"
  }, {
    path: "/news",
    component: _15836661,
    name: "news___en"
  }, {
    path: "/news",
    component: _15836661,
    name: "news___en"
  }, {
    path: "/promo",
    component: _458060d2,
    name: "promo___en"
  }, {
    path: "/promo",
    component: _458060d2,
    name: "promo___uk"
  }, {
    path: "/promo",
    component: _458060d2,
    name: "promo___bg"
  }, {
    path: "/promo",
    component: _458060d2,
    name: "promo___cs"
  }, {
    path: "/promo",
    component: _458060d2,
    name: "promo___ro"
  }, {
    path: "/promo",
    component: _458060d2,
    name: "promo___sk"
  }, {
    path: "/promo",
    component: _458060d2,
    name: "promo___ru"
  }, {
    path: "/promo",
    component: _458060d2,
    name: "promo___en"
  }, {
    path: "/promo",
    component: _458060d2,
    name: "promo___en"
  }, {
    path: "/promo",
    component: _458060d2,
    name: "promo___en"
  }, {
    path: "/search",
    component: _012835f3,
    children: [{
      path: "",
      component: _77c33a36,
      name: "search___en"
    }, {
      path: "drivers",
      component: _630251a2,
      name: "search-drivers___en"
    }, {
      path: "faqs",
      component: _d3161a2e,
      name: "search-faqs___en"
    }, {
      path: "news",
      component: _99574ac2,
      name: "search-news___en"
    }, {
      path: "products",
      component: _148e76b0,
      name: "search-products___en"
    }]
  }, {
    path: "/search",
    component: _012835f3,
    children: [{
      path: "",
      component: _77c33a36,
      name: "search___uk"
    }, {
      path: "drivers",
      component: _630251a2,
      name: "search-drivers___uk"
    }, {
      path: "faqs",
      component: _d3161a2e,
      name: "search-faqs___uk"
    }, {
      path: "news",
      component: _99574ac2,
      name: "search-news___uk"
    }, {
      path: "products",
      component: _148e76b0,
      name: "search-products___uk"
    }]
  }, {
    path: "/search",
    component: _012835f3,
    children: [{
      path: "",
      component: _77c33a36,
      name: "search___bg"
    }, {
      path: "drivers",
      component: _630251a2,
      name: "search-drivers___bg"
    }, {
      path: "faqs",
      component: _d3161a2e,
      name: "search-faqs___bg"
    }, {
      path: "news",
      component: _99574ac2,
      name: "search-news___bg"
    }, {
      path: "products",
      component: _148e76b0,
      name: "search-products___bg"
    }]
  }, {
    path: "/search",
    component: _012835f3,
    children: [{
      path: "",
      component: _77c33a36,
      name: "search___cs"
    }, {
      path: "drivers",
      component: _630251a2,
      name: "search-drivers___cs"
    }, {
      path: "faqs",
      component: _d3161a2e,
      name: "search-faqs___cs"
    }, {
      path: "news",
      component: _99574ac2,
      name: "search-news___cs"
    }, {
      path: "products",
      component: _148e76b0,
      name: "search-products___cs"
    }]
  }, {
    path: "/search",
    component: _012835f3,
    children: [{
      path: "",
      component: _77c33a36,
      name: "search___ro"
    }, {
      path: "drivers",
      component: _630251a2,
      name: "search-drivers___ro"
    }, {
      path: "faqs",
      component: _d3161a2e,
      name: "search-faqs___ro"
    }, {
      path: "news",
      component: _99574ac2,
      name: "search-news___ro"
    }, {
      path: "products",
      component: _148e76b0,
      name: "search-products___ro"
    }]
  }, {
    path: "/search",
    component: _012835f3,
    children: [{
      path: "",
      component: _77c33a36,
      name: "search___sk"
    }, {
      path: "drivers",
      component: _630251a2,
      name: "search-drivers___sk"
    }, {
      path: "faqs",
      component: _d3161a2e,
      name: "search-faqs___sk"
    }, {
      path: "news",
      component: _99574ac2,
      name: "search-news___sk"
    }, {
      path: "products",
      component: _148e76b0,
      name: "search-products___sk"
    }]
  }, {
    path: "/search",
    component: _012835f3,
    children: [{
      path: "",
      component: _77c33a36,
      name: "search___ru"
    }, {
      path: "drivers",
      component: _630251a2,
      name: "search-drivers___ru"
    }, {
      path: "faqs",
      component: _d3161a2e,
      name: "search-faqs___ru"
    }, {
      path: "news",
      component: _99574ac2,
      name: "search-news___ru"
    }, {
      path: "products",
      component: _148e76b0,
      name: "search-products___ru"
    }]
  }, {
    path: "/search",
    component: _012835f3,
    children: [{
      path: "",
      component: _77c33a36,
      name: "search___en"
    }, {
      path: "drivers",
      component: _630251a2,
      name: "search-drivers___en"
    }, {
      path: "faqs",
      component: _d3161a2e,
      name: "search-faqs___en"
    }, {
      path: "news",
      component: _99574ac2,
      name: "search-news___en"
    }, {
      path: "products",
      component: _148e76b0,
      name: "search-products___en"
    }]
  }, {
    path: "/search",
    component: _012835f3,
    children: [{
      path: "",
      component: _77c33a36,
      name: "search___en"
    }, {
      path: "drivers",
      component: _630251a2,
      name: "search-drivers___en"
    }, {
      path: "faqs",
      component: _d3161a2e,
      name: "search-faqs___en"
    }, {
      path: "news",
      component: _99574ac2,
      name: "search-news___en"
    }, {
      path: "products",
      component: _148e76b0,
      name: "search-products___en"
    }]
  }, {
    path: "/search",
    component: _012835f3,
    children: [{
      path: "",
      component: _77c33a36,
      name: "search___en"
    }, {
      path: "drivers",
      component: _630251a2,
      name: "search-drivers___en"
    }, {
      path: "faqs",
      component: _d3161a2e,
      name: "search-faqs___en"
    }, {
      path: "news",
      component: _99574ac2,
      name: "search-news___en"
    }, {
      path: "products",
      component: _148e76b0,
      name: "search-products___en"
    }]
  }, {
    path: "/user-help-desk",
    component: _ea0fdc1e,
    name: "user-help-desk___en"
  }, {
    path: "/user-help-desk",
    component: _ea0fdc1e,
    name: "user-help-desk___uk"
  }, {
    path: "/user-help-desk",
    component: _ea0fdc1e,
    name: "user-help-desk___bg"
  }, {
    path: "/user-help-desk",
    component: _ea0fdc1e,
    name: "user-help-desk___cs"
  }, {
    path: "/user-help-desk",
    component: _ea0fdc1e,
    name: "user-help-desk___ro"
  }, {
    path: "/user-help-desk",
    component: _ea0fdc1e,
    name: "user-help-desk___sk"
  }, {
    path: "/user-help-desk",
    component: _ea0fdc1e,
    name: "user-help-desk___ru"
  }, {
    path: "/user-help-desk",
    component: _ea0fdc1e,
    name: "user-help-desk___en"
  }, {
    path: "/user-help-desk",
    component: _ea0fdc1e,
    name: "user-help-desk___en"
  }, {
    path: "/user-help-desk",
    component: _ea0fdc1e,
    name: "user-help-desk___en"
  }, {
    path: "/where-to-buy",
    component: _50d193a8,
    name: "where-to-buy___en"
  }, {
    path: "/where-to-buy",
    component: _50d193a8,
    name: "where-to-buy___uk"
  }, {
    path: "/where-to-buy",
    component: _50d193a8,
    name: "where-to-buy___bg"
  }, {
    path: "/where-to-buy",
    component: _50d193a8,
    name: "where-to-buy___cs"
  }, {
    path: "/where-to-buy",
    component: _50d193a8,
    name: "where-to-buy___ro"
  }, {
    path: "/where-to-buy",
    component: _50d193a8,
    name: "where-to-buy___sk"
  }, {
    path: "/where-to-buy",
    component: _50d193a8,
    name: "where-to-buy___ru"
  }, {
    path: "/where-to-buy",
    component: _50d193a8,
    name: "where-to-buy___en"
  }, {
    path: "/where-to-buy",
    component: _50d193a8,
    name: "where-to-buy___en"
  }, {
    path: "/where-to-buy",
    component: _50d193a8,
    name: "where-to-buy___en"
  }, {
    path: "/user-help-desk/faq",
    component: _cb6c3a90,
    name: "user-help-desk-faq___en"
  }, {
    path: "/user-help-desk/faq",
    component: _cb6c3a90,
    name: "user-help-desk-faq___uk"
  }, {
    path: "/user-help-desk/faq",
    component: _cb6c3a90,
    name: "user-help-desk-faq___bg"
  }, {
    path: "/user-help-desk/faq",
    component: _cb6c3a90,
    name: "user-help-desk-faq___cs"
  }, {
    path: "/user-help-desk/faq",
    component: _cb6c3a90,
    name: "user-help-desk-faq___ro"
  }, {
    path: "/user-help-desk/faq",
    component: _cb6c3a90,
    name: "user-help-desk-faq___sk"
  }, {
    path: "/user-help-desk/faq",
    component: _cb6c3a90,
    name: "user-help-desk-faq___ru"
  }, {
    path: "/user-help-desk/faq",
    component: _cb6c3a90,
    name: "user-help-desk-faq___en"
  }, {
    path: "/user-help-desk/faq",
    component: _cb6c3a90,
    name: "user-help-desk-faq___en"
  }, {
    path: "/user-help-desk/faq",
    component: _cb6c3a90,
    name: "user-help-desk-faq___en"
  }, {
    path: "/",
    component: _e1b72352,
    name: "index___en"
  }, {
    path: "/",
    component: _e1b72352,
    name: "index___uk"
  }, {
    path: "/",
    component: _e1b72352,
    name: "index___bg"
  }, {
    path: "/",
    component: _e1b72352,
    name: "index___cs"
  }, {
    path: "/",
    component: _e1b72352,
    name: "index___ro"
  }, {
    path: "/",
    component: _e1b72352,
    name: "index___sk"
  }, {
    path: "/",
    component: _e1b72352,
    name: "index___ru"
  }, {
    path: "/",
    component: _e1b72352,
    name: "index___en"
  }, {
    path: "/",
    component: _e1b72352,
    name: "index___en"
  }, {
    path: "/",
    component: _e1b72352,
    name: "index___en"
  }, {
    path: "/user-help-desk/faq/:slug?",
    component: _ced97d20,
    name: "user-help-desk-faq-slug___en"
  }, {
    path: "/user-help-desk/faq/:slug?",
    component: _ced97d20,
    name: "user-help-desk-faq-slug___uk"
  }, {
    path: "/user-help-desk/faq/:slug?",
    component: _ced97d20,
    name: "user-help-desk-faq-slug___bg"
  }, {
    path: "/user-help-desk/faq/:slug?",
    component: _ced97d20,
    name: "user-help-desk-faq-slug___cs"
  }, {
    path: "/user-help-desk/faq/:slug?",
    component: _ced97d20,
    name: "user-help-desk-faq-slug___ro"
  }, {
    path: "/user-help-desk/faq/:slug?",
    component: _ced97d20,
    name: "user-help-desk-faq-slug___sk"
  }, {
    path: "/user-help-desk/faq/:slug?",
    component: _ced97d20,
    name: "user-help-desk-faq-slug___ru"
  }, {
    path: "/user-help-desk/faq/:slug?",
    component: _ced97d20,
    name: "user-help-desk-faq-slug___en"
  }, {
    path: "/user-help-desk/faq/:slug?",
    component: _ced97d20,
    name: "user-help-desk-faq-slug___en"
  }, {
    path: "/user-help-desk/faq/:slug?",
    component: _ced97d20,
    name: "user-help-desk-faq-slug___en"
  }, {
    path: "/certificates/:slug",
    component: _58790c7c,
    name: "certificates-slug___en"
  }, {
    path: "/certificates/:slug",
    component: _58790c7c,
    name: "certificates-slug___uk"
  }, {
    path: "/certificates/:slug",
    component: _58790c7c,
    name: "certificates-slug___bg"
  }, {
    path: "/certificates/:slug",
    component: _58790c7c,
    name: "certificates-slug___cs"
  }, {
    path: "/certificates/:slug",
    component: _58790c7c,
    name: "certificates-slug___ro"
  }, {
    path: "/certificates/:slug",
    component: _58790c7c,
    name: "certificates-slug___sk"
  }, {
    path: "/certificates/:slug",
    component: _58790c7c,
    name: "certificates-slug___ru"
  }, {
    path: "/certificates/:slug",
    component: _58790c7c,
    name: "certificates-slug___en"
  }, {
    path: "/certificates/:slug",
    component: _58790c7c,
    name: "certificates-slug___en"
  }, {
    path: "/certificates/:slug",
    component: _58790c7c,
    name: "certificates-slug___en"
  }, {
    path: "/news/:slug",
    component: _13ccc519,
    name: "news-slug___en"
  }, {
    path: "/news/:slug",
    component: _13ccc519,
    name: "news-slug___uk"
  }, {
    path: "/news/:slug",
    component: _13ccc519,
    name: "news-slug___bg"
  }, {
    path: "/news/:slug",
    component: _13ccc519,
    name: "news-slug___cs"
  }, {
    path: "/news/:slug",
    component: _13ccc519,
    name: "news-slug___ro"
  }, {
    path: "/news/:slug",
    component: _13ccc519,
    name: "news-slug___sk"
  }, {
    path: "/news/:slug",
    component: _13ccc519,
    name: "news-slug___ru"
  }, {
    path: "/news/:slug",
    component: _13ccc519,
    name: "news-slug___en"
  }, {
    path: "/news/:slug",
    component: _13ccc519,
    name: "news-slug___en"
  }, {
    path: "/news/:slug",
    component: _13ccc519,
    name: "news-slug___en"
  }, {
    path: "/product-category/:category",
    component: _3af49a90,
    name: "product-category-category___en"
  }, {
    path: "/product-category/:category",
    component: _3af49a90,
    name: "product-category-category___uk"
  }, {
    path: "/product-category/:category",
    component: _3af49a90,
    name: "product-category-category___bg"
  }, {
    path: "/product-category/:category",
    component: _3af49a90,
    name: "product-category-category___cs"
  }, {
    path: "/product-category/:category",
    component: _3af49a90,
    name: "product-category-category___ro"
  }, {
    path: "/product-category/:category",
    component: _3af49a90,
    name: "product-category-category___sk"
  }, {
    path: "/product-category/:category",
    component: _3af49a90,
    name: "product-category-category___ru"
  }, {
    path: "/product-category/:category",
    component: _3af49a90,
    name: "product-category-category___en"
  }, {
    path: "/product-category/:category",
    component: _3af49a90,
    name: "product-category-category___en"
  }, {
    path: "/product-category/:category",
    component: _3af49a90,
    name: "product-category-category___en"
  }, {
    path: "/product/:slug?",
    component: _5de9fa22,
    name: "product-slug___en"
  }, {
    path: "/product/:slug?",
    component: _5de9fa22,
    name: "product-slug___uk"
  }, {
    path: "/product/:slug?",
    component: _5de9fa22,
    name: "product-slug___bg"
  }, {
    path: "/product/:slug?",
    component: _5de9fa22,
    name: "product-slug___cs"
  }, {
    path: "/product/:slug?",
    component: _5de9fa22,
    name: "product-slug___ro"
  }, {
    path: "/product/:slug?",
    component: _5de9fa22,
    name: "product-slug___sk"
  }, {
    path: "/product/:slug?",
    component: _5de9fa22,
    name: "product-slug___ru"
  }, {
    path: "/product/:slug?",
    component: _5de9fa22,
    name: "product-slug___en"
  }, {
    path: "/product/:slug?",
    component: _5de9fa22,
    name: "product-slug___en"
  }, {
    path: "/product/:slug?",
    component: _5de9fa22,
    name: "product-slug___en"
  }, {
    path: "/promo/:slug",
    component: _48eda362,
    name: "promo-slug___en"
  }, {
    path: "/promo/:slug",
    component: _48eda362,
    name: "promo-slug___uk"
  }, {
    path: "/promo/:slug",
    component: _48eda362,
    name: "promo-slug___bg"
  }, {
    path: "/promo/:slug",
    component: _48eda362,
    name: "promo-slug___cs"
  }, {
    path: "/promo/:slug",
    component: _48eda362,
    name: "promo-slug___ro"
  }, {
    path: "/promo/:slug",
    component: _48eda362,
    name: "promo-slug___sk"
  }, {
    path: "/promo/:slug",
    component: _48eda362,
    name: "promo-slug___ru"
  }, {
    path: "/promo/:slug",
    component: _48eda362,
    name: "promo-slug___en"
  }, {
    path: "/promo/:slug",
    component: _48eda362,
    name: "promo-slug___en"
  }, {
    path: "/promo/:slug",
    component: _48eda362,
    name: "promo-slug___en"
  }, {
    path: "/product-category/:category?/:subcategory",
    component: _50746768,
    name: "product-category-category-subcategory___en"
  }, {
    path: "/product-category/:category?/:subcategory",
    component: _50746768,
    name: "product-category-category-subcategory___uk"
  }, {
    path: "/product-category/:category?/:subcategory",
    component: _50746768,
    name: "product-category-category-subcategory___bg"
  }, {
    path: "/product-category/:category?/:subcategory",
    component: _50746768,
    name: "product-category-category-subcategory___cs"
  }, {
    path: "/product-category/:category?/:subcategory",
    component: _50746768,
    name: "product-category-category-subcategory___ro"
  }, {
    path: "/product-category/:category?/:subcategory",
    component: _50746768,
    name: "product-category-category-subcategory___sk"
  }, {
    path: "/product-category/:category?/:subcategory",
    component: _50746768,
    name: "product-category-category-subcategory___ru"
  }, {
    path: "/product-category/:category?/:subcategory",
    component: _50746768,
    name: "product-category-category-subcategory___en"
  }, {
    path: "/product-category/:category?/:subcategory",
    component: _50746768,
    name: "product-category-category-subcategory___en"
  }, {
    path: "/product-category/:category?/:subcategory",
    component: _50746768,
    name: "product-category-category-subcategory___en"
  }, {
    path: "/product-category/:category?/:subcategory?/:subsubcategory",
    component: _5cd98fda,
    name: "product-category-category-subcategory-subsubcategory___en"
  }, {
    path: "/product-category/:category?/:subcategory?/:subsubcategory",
    component: _5cd98fda,
    name: "product-category-category-subcategory-subsubcategory___uk"
  }, {
    path: "/product-category/:category?/:subcategory?/:subsubcategory",
    component: _5cd98fda,
    name: "product-category-category-subcategory-subsubcategory___bg"
  }, {
    path: "/product-category/:category?/:subcategory?/:subsubcategory",
    component: _5cd98fda,
    name: "product-category-category-subcategory-subsubcategory___cs"
  }, {
    path: "/product-category/:category?/:subcategory?/:subsubcategory",
    component: _5cd98fda,
    name: "product-category-category-subcategory-subsubcategory___ro"
  }, {
    path: "/product-category/:category?/:subcategory?/:subsubcategory",
    component: _5cd98fda,
    name: "product-category-category-subcategory-subsubcategory___sk"
  }, {
    path: "/product-category/:category?/:subcategory?/:subsubcategory",
    component: _5cd98fda,
    name: "product-category-category-subcategory-subsubcategory___ru"
  }, {
    path: "/product-category/:category?/:subcategory?/:subsubcategory",
    component: _5cd98fda,
    name: "product-category-category-subcategory-subsubcategory___en"
  }, {
    path: "/product-category/:category?/:subcategory?/:subsubcategory",
    component: _5cd98fda,
    name: "product-category-category-subcategory-subsubcategory___en"
  }, {
    path: "/product-category/:category?/:subcategory?/:subsubcategory",
    component: _5cd98fda,
    name: "product-category-category-subcategory-subsubcategory___en"
  }, {
    path: "/product-category/:category?/:subcategory?/:subsubcategory/:subsubsubcategory",
    component: _0bc54daa,
    name: "product-category-category-subcategory-subsubcategory-subsubsubcategory___en"
  }, {
    path: "/product-category/:category?/:subcategory?/:subsubcategory/:subsubsubcategory",
    component: _0bc54daa,
    name: "product-category-category-subcategory-subsubcategory-subsubsubcategory___uk"
  }, {
    path: "/product-category/:category?/:subcategory?/:subsubcategory/:subsubsubcategory",
    component: _0bc54daa,
    name: "product-category-category-subcategory-subsubcategory-subsubsubcategory___bg"
  }, {
    path: "/product-category/:category?/:subcategory?/:subsubcategory/:subsubsubcategory",
    component: _0bc54daa,
    name: "product-category-category-subcategory-subsubcategory-subsubsubcategory___cs"
  }, {
    path: "/product-category/:category?/:subcategory?/:subsubcategory/:subsubsubcategory",
    component: _0bc54daa,
    name: "product-category-category-subcategory-subsubcategory-subsubsubcategory___ro"
  }, {
    path: "/product-category/:category?/:subcategory?/:subsubcategory/:subsubsubcategory",
    component: _0bc54daa,
    name: "product-category-category-subcategory-subsubcategory-subsubsubcategory___sk"
  }, {
    path: "/product-category/:category?/:subcategory?/:subsubcategory/:subsubsubcategory",
    component: _0bc54daa,
    name: "product-category-category-subcategory-subsubcategory-subsubsubcategory___ru"
  }, {
    path: "/product-category/:category?/:subcategory?/:subsubcategory/:subsubsubcategory",
    component: _0bc54daa,
    name: "product-category-category-subcategory-subsubcategory-subsubsubcategory___en"
  }, {
    path: "/product-category/:category?/:subcategory?/:subsubcategory/:subsubsubcategory",
    component: _0bc54daa,
    name: "product-category-category-subcategory-subsubcategory-subsubsubcategory___en"
  }, {
    path: "/product-category/:category?/:subcategory?/:subsubcategory/:subsubsubcategory",
    component: _0bc54daa,
    name: "product-category-category-subcategory-subsubcategory-subsubsubcategory___en"
  }, {
    path: "/:slug",
    component: _e52465e2,
    name: "slug___en"
  }, {
    path: "/:slug",
    component: _e52465e2,
    name: "slug___uk"
  }, {
    path: "/:slug",
    component: _e52465e2,
    name: "slug___bg"
  }, {
    path: "/:slug",
    component: _e52465e2,
    name: "slug___cs"
  }, {
    path: "/:slug",
    component: _e52465e2,
    name: "slug___ro"
  }, {
    path: "/:slug",
    component: _e52465e2,
    name: "slug___sk"
  }, {
    path: "/:slug",
    component: _e52465e2,
    name: "slug___ru"
  }, {
    path: "/:slug",
    component: _e52465e2,
    name: "slug___en"
  }, {
    path: "/:slug",
    component: _e52465e2,
    name: "slug___en"
  }, {
    path: "/:slug",
    component: _e52465e2,
    name: "slug___en"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
